export const SITE = {
  brand: "STJ Innovations",
  shortBrand: "STJ",
  legalName: "STJ Innovations LLP",
  tagline: "Clean Spaces | Better Tomorrow",
  positioning: "Engineered for Controlled Environments.",
  subtitle: "Pharmaceutical Cleanroom Equipment & Precision Engineering Solutions",
  url: "https://stjinnovations.com",
};

// Analytics: set IDs via env to activate (no fake IDs hard-coded)
// REACT_APP_GA_ID, REACT_APP_GTM_ID, REACT_APP_META_PIXEL_ID, REACT_APP_LINKEDIN_PARTNER_ID
export const ANALYTICS = {
  gaId: process.env.REACT_APP_GA_ID || "",
  gtmId: process.env.REACT_APP_GTM_ID || "",
  metaPixelId: process.env.REACT_APP_META_PIXEL_ID || "",
  linkedInPartnerId: process.env.REACT_APP_LINKEDIN_PARTNER_ID || "",
};

export const NAV_LINKS = [
  { label: "Products", to: "/products", testId: "nav-link-products", dropdown: true },
  { label: "Industries", to: "/industries", testId: "nav-link-industries" },
  { label: "Capabilities", to: "/capabilities", testId: "nav-link-capabilities" },
  { label: "Quality", to: "/quality", testId: "nav-link-quality" },
  { label: "Knowledge Center", to: "/knowledge-center", testId: "nav-link-knowledge" },
  { label: "About", to: "/about", testId: "nav-link-about" },
  { label: "Resources", to: "/resources", testId: "nav-link-resources" },
  { label: "Insights", to: "/insights", testId: "nav-link-insights" },
];
